export default function H4({ text }: header) {
  return (
    <h4 className="text-lg font-medium leading-6 text-gray-900">{text}</h4>
  );
}

interface header {
  text: string;
}
